import { DateRange, Grid } from 'bold-ui'
import { CboSelectModel, EquipeSelectModel, ProfissionalSelectModel } from 'components/form'
import { CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { useFlags } from 'config/useFlagsContext'
import { format } from 'date-fns'

import { HistoricoAtendimentoAdvancedFilterFormModel } from '../../model/model-historico'
import HistoricoAtendimentoFilterItem from './HistoricoAtendimentoFilterItem'

export interface HistoricoAtendimentoActiveFiltersProps {
  filters: HistoricoAtendimentoAdvancedFilterFormModel
}

const periodoText = ({ startDate, endDate }: DateRange) => {
  return startDate && endDate && `(${format(startDate, 'dd/MM/yyyy')} até ${format(endDate, 'dd/MM/yyyy')})`
}

const cbosText = (cbos: CboSelectModel[]) => cbos.map((cbo) => cbo.nome).join(', ')

const equipeText = (equipes: EquipeSelectModel[]) => equipes.map((equipe) => equipe.nome).join(', ')

const profissionaisText = (profissionais: ProfissionalSelectModel[]) =>
  profissionais.map((profissional) => profissional.nome).join(', ')

const ciapsText = (ciaps: CiapSelectFieldModel[]) => ciaps.map((ciap) => ciap.descricao).join(', ')

const cidsText = (cids: CidSelectFieldModel[]) => cids.map((cid) => cid.nome).join(', ')

export default function HistoricoAtendimentoActiveFilters({ filters }: HistoricoAtendimentoActiveFiltersProps) {
  const { periodo, cbos, equipes, profissionais, ciaps2, cids10, exibirRegistrosInativos } = filters

  const {
    PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED,
    RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED,
    RETIFICACAO_ATENDIMENTO_INDIVIDUAL_ENABLED,
  } = useFlags()

  const isFlagRetificacaoEnabled =
    PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED ||
    RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED ||
    RETIFICACAO_ATENDIMENTO_INDIVIDUAL_ENABLED

  return (
    <Grid alignItems='center' justifyContent='flex-start' gap={0.25} gapVertical={0.25} wrap={false}>
      {periodo?.startDate && periodo?.endDate && (
        <HistoricoAtendimentoFilterItem label='Período' text={periodoText(periodo)} filters={filters} />
      )}
      {cbos && cbos.length !== 0 && (
        <HistoricoAtendimentoFilterItem label='CBO' text={cbosText(filters.cbos)} filters={filters} />
      )}
      {equipes && equipes.length !== 0 && (
        <HistoricoAtendimentoFilterItem label='Equipe' text={equipeText(equipes)} filters={filters} />
      )}
      {profissionais && profissionais.length !== 0 && (
        <HistoricoAtendimentoFilterItem
          label='Profissional'
          text={profissionaisText(profissionais)}
          filters={filters}
        />
      )}
      {ciaps2 && ciaps2.length !== 0 && (
        <HistoricoAtendimentoFilterItem label='CIAP2' text={ciapsText(ciaps2)} filters={filters} />
      )}
      {cids10 && cids10.length !== 0 && (
        <HistoricoAtendimentoFilterItem label='CID10' text={cidsText(cids10)} filters={filters} />
      )}
      {isFlagRetificacaoEnabled && (
        <HistoricoAtendimentoFilterItem
          label='Exibir registros removidos'
          text={exibirRegistrosInativos ? 'Sim' : 'Não'}
          filters={filters}
        />
      )}
    </Grid>
  )
}
